import { render, staticRenderFns } from "./AdminIdeaDetailPage.vue?vue&type=template&id=649bc706&"
import script from "./AdminIdeaDetailPage.vue?vue&type=script&lang=ts&"
export * from "./AdminIdeaDetailPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports